__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/bfb29aed256f747be466a8985c3285353e50f96a66000469c8ca95ff/";